<template>
<div class="chapter">
<div class="inner_page">
<p class="ct2"><a id="page_v">Praise for John A. Daly and <i>Broken Slate</i></a></p><a id="page_v">
<p class="tx1">“John Daly has a magical writing style, and his books keep you up late at night turning pages. Sean, the protagonist, helps you see the world through his eyes in a total escape from daily life. You won’t want to put it down.”</p>
<p class="txr"><b>— Dana Perino, Former White House Press Secretary</b></p>
<p class="tx1-1">“Crackling with gunfire and suspense, the opening pages of BROKEN SLATE make clear that John A. Daly writes with assurance and style -- and without fear or political correctness. This third installment in the Sean Coleman series brings us an engrossing thriller, centered around a deeply flawed but compelling character: an antihero for the post-9/11 age.”</p>
<p class="txr"><b>— James Rosen, Fox News chief Washington correspondent and author of <i>The Strong Man</i> and <i>Cheney One On One</i></b></p>
<p class="tx1-1">“What a great f***ing book. Seriously... Sean Coleman is the kind of character that pisses you off—he’s emotionally broken, often thoughtless, and sometimes a jerk. He’s also loyal, honorable, and anything but a super hero. In short, John Daly’s Sean Coleman is a lot like you and me.”</p>
<p class="txr"><b>—Terry Schappert, U.S. Army Special Forces, and host of Warriors, Shark Attack Survival Guide, Dude You’re Screwed!, and Hollywood Weapons: Fact or Fiction?</b></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?447a3a98